import React from "react";
import { Plus, X } from "lucide-react";
import { UploadButton } from "./UploadButton";

// Generic key/value pair list editor (used for specs and floorplans)
export function DynamicPairField({ label, items, onChange, keyName, valName, keyPlaceholder, valPlaceholder, addLabel, testId, valUploadAccept }) {
  const update = (i, field, val) => {
    const next = items.map((it, idx) => (idx === i ? { ...it, [field]: val } : it));
    onChange(next);
  };
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const add = () => onChange([...items, { [keyName]: "", [valName]: "" }]);

  return (
    <div>
      <label className="block text-[11px] tracking-[0.2em] uppercase text-white/50 mb-3">{label}</label>
      <div className="space-y-2">
        {items.map((it, i) => (
          <div key={i} className="flex items-center gap-2">
            <input
              value={it[keyName] || ""}
              onChange={(e) => update(i, keyName, e.target.value)}
              placeholder={keyPlaceholder}
              data-testid={`${testId}-key-${i}`}
              className="flex-1 bg-white/5 border border-white/15 px-3 py-2.5 text-sm text-white focus:border-white/50 outline-none"
            />
            <input
              value={it[valName] || ""}
              onChange={(e) => update(i, valName, e.target.value)}
              placeholder={valPlaceholder}
              data-testid={`${testId}-val-${i}`}
              className="flex-1 bg-white/5 border border-white/15 px-3 py-2.5 text-sm text-white focus:border-white/50 outline-none"
            />
            {valUploadAccept && (
              <UploadButton
                accept={valUploadAccept}
                onUploaded={(url) => update(i, valName, url)}
                testId={`${testId}-upload-${i}`}
              />
            )}
            <button
              type="button"
              onClick={() => remove(i)}
              data-testid={`${testId}-remove-${i}`}
              className="w-9 h-9 shrink-0 border border-white/15 hover:border-white flex items-center justify-center transition-colors"
            >
              <X size={14} strokeWidth={1.5} />
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={add}
        data-testid={`${testId}-add`}
        className="mt-3 inline-flex items-center gap-2 text-xs tracking-[0.15em] uppercase text-white/60 hover:text-white transition-colors"
      >
        <Plus size={14} strokeWidth={1.5} /> {addLabel}
      </button>
    </div>
  );
}
